import { useQuery } from '@tanstack/react-query';

import { CashdesksService } from 'shared/services/cashdesk.service';

export const useGetCashdesks = () => {
  const {
    isLoading: isCashdesksLoading,
    data: cashdesks,
    isError: isCashdesksError,
    ...restData
  } = useQuery({
    queryFn: () => CashdesksService.getCashdesks(),
    queryKey: ['get cashdesks'],
    retry: 0,
    select: ({ data }) => data.items
  });

  return { isCashdesksLoading, cashdesks, isCashdesksError, ...restData };
};
